import { useSyncExternalStore } from 'react';
import { getSession, subscribeSession } from '../lib/auth';

/** Reflete a sessão persistida (Dexie) — `main.tsx` garante que já foi carregada. */
export function useAuth() {
  const session = useSyncExternalStore(subscribeSession, getSession, getSession);
  return { session, isAuthenticated: session !== undefined };
}
